import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import iconFailure from '../../../../../../assets/img/failedPurchase.svg';
import { CompletedPaymentContainer } from '../../styles';
import { sendEvent, NO_RETRY_EVENT, track } from '../../../../../utils/trackingEvent';
import { useStepperCtx } from '../../../../stepper';
import { selectProductTaxesParams } from '../../../../../ducks/step4Module2';

function PaymentError() {
  const { productId } = useSelector(selectProductTaxesParams);
  const { setPreventTransition } = useStepperCtx();
  const { t } = useTranslation();

  const notifyNoReintent = () => {
    if (productId) {
      track(NO_RETRY_EVENT, productId);
    }
  };

  useEffect(() => {
    sendEvent('Planes Modulo2', 'error');
    window.dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'Ecommerce',
      eventAction: 'Purchase Rejected',
      eventLabel: 'Aviso Particulares'
    });
    setPreventTransition(false);
    window.addEventListener('beforeunload', notifyNoReintent);
    return () => {
      window.removeEventListener('beforeunload', notifyNoReintent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CompletedPaymentContainer>
      <img src={iconFailure} alt='failedPurchase' />
      <h3>{t('publisher.step4.module2.payment.error.title')}</h3>
      <p>{t('publisher.step4.module2.payment.error.message')}</p>
    </CompletedPaymentContainer>
  );
}

export default PaymentError;
